import React from 'react'
import Banner from '../../Components/Banner/Banner'
import MainForm from '../../Components/MainForm/MainForm' 
import SimpleReactValidator from 'simple-react-validator';
// import compact from 'lodash/compact';
import { filterCountries } from '../../Shared/Contries';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
class CheckEligibility extends React.Component{  
    constructor() {
        super()
        this.state={ 
           showbtn : true,
           showCountries : false,
           toggleIelts: true,
           user :{
                pfirstname: '',
                plastname: '',
                pemail: '',
                pphone : '',
                gender : 'male',
                dateofbirth:'',
                paddress: '',
                qalifications : 'selectQualification',
                institute: '',
                datefrom : '',
                dateto : '', 
                ieltsBand: '',
                marks: '' ,
                country: ''      
           },
           errors:{}
       }
       this.validator = new SimpleReactValidator();
    }
    filterCountries = (program, marks, ielts) => {
        return this.props.countries.filter((country) => {
            const cp = this.findProgram(program, country.programs);
            if (cp) {
            return marks >= cp.minMarks && ielts >= cp.minIelts;
            }
            return false;
        });
    };
    findProgram = (program, programs) => {
        return programs.find((item) => item.name === program);
    };
    handleUserInput=(e)=>{ 
        const value = e.target.value;
        this.setState({ 
            user:{
            ...this.state.user,
            [e.target.name] : value
            }
        })        
    }
    submitForm =(event)=> {
        event.preventDefault();      
        if (this.validator.allValid()) {
             this.props.onSetCountry(this.state.user.country);
             this.props.history.push(`/eligibility/${this.state.user.country.toLocaleLowerCase()}/step1`);
        } else {
          this.validator.showMessages();
          this.forceUpdate();
        }
    }
    onInputBlur =()=>{
        const { qalifications } = this.state.user;
        let err ={};
        if(qalifications === 'selectQualification'){
            err.qalifications = "Select any Qualification"
            this.setState({
                errors : err
            })
        }
        else{
            this.setState({
                errors : {}
            })
        }
    }
    toggleContainer = ()=>{
        const { qalifications } = this.state.user;
        let err ={};
        if(qalifications === 'selectQualification'){
            err.qalifications = "Select any Qualification"
        }
        else{
            err ={}
        }
        this.setState({ errors: err }, () => {
            if (Object.getOwnPropertyNames(this.state.errors).length === 0) {
                this.setState((prevState)=>{
                    return{
                        showbtn : !prevState.showbtn,
                        showCountries : !prevState.showCountries

                    }
                })
            }
        });
        
    }
    toggleIeltSection =()=>{
        this.setState((prevState)=>{
            return{
                toggleIelts : !prevState.toggleIelts
            }
        })
    }
     render(){
         return(
             <>
                <Banner brand="main">
                 <h1 className="bg-text1 mb-1">Checking</h1>
                 <h1 className="bg-text1 mb-1"><span className="text-color2">Eligibility</span> for you</h1>
                </Banner>
                <div className="my-3">
                    <h2 className="text-color1 text-center heading2">Fill the Form</h2>
                </div>     
                <MainForm> 
                    <form action="" method="post">
                        <div className="form-container mb-4">
                            <h4 className="heading4 text-color2 mb-3 pl-3">Personal Details</h4>
                            <div className="form-wrap mc-border">               
                                    <div className="f-row">
                                        <div className="fr-left">
                                            <div className="form-group">
                                                    <label htmlFor="pfirstname" className="form-label1">First Name</label>
                                                    <input id="pfirstname" className="form-control form-input1"  name="pfirstname" value={ this.state.user.pfirstname } placeholder="First Name" onChange={this.handleUserInput} />
                                                    {this.validator.message('First Name', this.state.user.pfirstname, 'required|alpha')}
                                            </div>
                                        </div>
                                        <div className="fr-right">
                                            <div className="form-group">
                                                    <label htmlFor="plastName" className="form-label1">Last Name</label>
                                                    <input id="plastName" className="form-control form-input1" type="text" name="plastname" value={ this.state.user.plastname } placeholder="Last Name" onChange={this.handleUserInput} />
                                                    {this.validator.message('Last Name', this.state.user.plastname, 'required|alpha')}
                                            </div>
                                        </div>
                                    </div>    
                                    <div className="f-row">
                                            <div className="fr-left">
                                                <div className="form-group">
                                                        <label htmlFor="pemail" className="form-label1">Email</label>
                                                        <input id="pemail" name="pemail" className="form-control form-input1" value={this.state.user.pemail} type="text"  placeholder="Email"  onChange={this.handleUserInput}/>
                                                        {this.validator.message('email', this.state.user.pemail, 'required|email', { className: 'text-danger' })}
                                                </div>
                                            </div>
                                            <div className="fr-right">
                                                <div className="form-group">
                                                        <label htmlFor="pphone" className="form-label1">Phone</label>
                                                        <input id="pphone" name="pphone" className="form-control form-input1" value={this.state.user.pphone} type="text"   placeholder="0000" onChange={this.handleUserInput} />
                                                        {this.validator.message('Phone', this.state.user.pphone, 'required|phone', { className: 'text-danger' })}
                                                </div>
                                            </div>
                                    </div>
                                    <div className="f-row">
                                        <div className="fr-left">
                                            <div className="form-group">
                                                    <label htmlFor="pGender" className="form-label1">Gender</label>                                 
                                                    <select id="selectGender" value={this.state.user.gender} className="custom-select form-input1" name="gender" onChange={this.handleUserInput}>
                                                        <option value="male">Male</option>
                                                        <option value="female">Female</option> 
                                                    </select>
                                            </div>
                                             
                                        </div>
                                        <div className="fr-right">
                                            <div className="form-group">
                                                    <label htmlFor="pbirthDate" className="form-label1">Date of Birth</label>
                                                    <input id="dateofbirth" name="dateofbirth" className="form-control form-input1" value={this.state.user.dateofbirth}   type="date" placeholder="Date of Birth" onChange={this.handleUserInput}  />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">                                    
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                    <label htmlFor="paddress" className="form-label1">Correspondence Address</label>
                                                    <textarea name="paddress" id="paddress" rows="5" className="form-control form-input1" value={this.state.user.paddress} onChange={this.handleUserInput}></textarea>
                                            </div> 
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div className="form-container mb-4">
                          <h4 className="heading4 text-color2 mb-3 pl-3">Education</h4>
                            <div className="form-wrap mc-border">                                
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label htmlFor="educationName" className="form-label1">Name of Qualifications</label>
                                                <select name="qalifications" id="educationName" value={this.state.user.qalifications} className="form-control form-input1"  onChange={this.handleUserInput} onBlur={this.onInputBlur}>
                                                    <option value="selectQualification">Select Qualification</option>
                                                    <option value="underGraduate">UnderGraduate</option>
                                                    <option value="masters">Masters</option>
                                                    <option value="diploma">Diploma</option>
                                                </select>
                                                <div className="error-text">{this.state.errors && this.state.errors.qalifications}</div>
                                            </div>                                            
                                        </div>  
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label htmlFor="educationInstitute" className="form-label1">Institute</label>
                                                <input id="educationInstitute" className="form-control form-input1" type="text" name="institute" value={this.state.user.institute} placeholder="Name" onChange={this.handleUserInput} />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="datefrom" className="form-label1">Date Attended (from)</label>
                                                <input id="datefrom" name="datefrom" className="form-control form-input1" type="date" value={this.state.user.datefrom}   onChange={this.handleUserInput}  />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="dateto" className="form-label1">Date Attended (to)</label>
                                                <input id="dateto" name="dateto" className="form-control form-input1" type="date" value={this.state.user.dateto} onChange={this.handleUserInput}  />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="pAddress" className="form-label1 ">Marks %</label>
                                                <input id="marks" className="form-control form-input1" type="number" min={1} max={100} value={ this.state.user.marks } name="marks" placeholder="0.00" onChange={this.handleUserInput}  />    
                                            </div>
                                        </div>
                                    </div>
                                 
                            </div>             
                        </div> 
                        <div className="form-container mb-4" style={{ display: this.state.toggleIelts? 'block' : 'none' }}>
                               <div className="d-flex justify-content-between">
                                    <h4 className="heading4 text-color2 mb-3 pl-3">Ilets</h4>
                                     <button type="button" className="btn btn-skip" onClick={this.toggleIeltSection}>Skip This Section</button>
                               </div>
                                <div className="form-wrap mc-border">                                
                                    <div className="row">                         
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label htmlFor="ieltsBand" className=" form-label1">Bands</label>
                                                <input id="ieltsBand" className="form-control form-input1" type="number" min={0} max={10} value={this.state.user.ieltsBand } name="ieltsBand" placeholder="Bands" onChange={this.handleUserInput} />
                                            </div>
                                        </div>                         
                                    </div>                                 
                                </div>
                        </div>  
                        <div className="text-center form-group" style={{ display: this.state.showbtn? 'block': 'none' }}>
                            <button type="button" className="btn btn-apply" onClick={this.toggleContainer}>Check Now</button>
                        </div> 
                        <div style={{ display: this.state.showCountries? 'block': 'none' }}>
                            <div className="form-container mb-4" >
                                   <h4 className="heading4 text-color2 mb-3 pl-3">Select Country</h4> 
                                    <div className="form-wrap mc-border">                               
                                        <div className="d-flex flex-md-row flex-column flex-wrap align-items-center">                                          
                                        {filterCountries(this.state.user.qalifications, this.state.user.marks, this.state.user.ieltsBand).map((country) => {               
                                            return(
                                                    <div key={country.name} className="flex-width">
                                                        <div className="form-group mb-0">
                                                            <div className="d-flex align-items-center">
                                                                    <input type="radio" name="country" value={country.name} onChange={this.handleUserInput} />
                                                                    <div  className="ml-3 d-flex flex-column align-items-center">     
                                                                        {/* <img src={ country.imageUrl } alt="usaImg" />                              */}
                                                                        <label htmlFor="ieltsBand"  className="label-radio mt-1">{country.name}</label>
                                                                    </div>
                                                            </div>
                                                        </div>
                                                </div>
                                            )
                                        })}        
                                    </div>                               
                                </div>
                            </div>
                            <div className="form-group text-right">
                                <button type="button" className="btn btn-apply" onClick={this.submitForm}>Apply Now</button>
                            </div> 
                        </div>
                    </form>
                </MainForm>          
             </>
         )
     }
}
const mapStateToProps = state=>{
    return{
        contries: state.contries
    }
}
const mapDispatchToProps = dispatch => {   
    return {
        onSetCountry: (name) => dispatch({type: 'SET_COUNTARY', name:name}) 
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CheckEligibility));